import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Megaphone, ArrowRight } from "lucide-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Compact card shown on dashboard home surfaces the single most recent
 * announcement targeted at the current user, with a link to the full
 * inbox. Hidden entirely when there are no announcements.
 */
export default function LatestAnnouncementCard() {
  const [latest, setLatest] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/announcements?limit=1").then((r) => {
      if (cancelled) return;
      setLatest((r.data?.items || [])[0] || null);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!latest) return null;
  const preview = (latest.body || "").slice(0, 280);
  const bodyOverflow = (latest.body || "").length > 280;

  return (
    <div className="kb-card p-5 border-l-4 border-l-kb-primary" data-testid="dashboard-latest-announcement">
      <div className="flex items-center justify-between gap-3">
        <div className="kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-primary flex items-center gap-2">
          <Megaphone className="w-3.5 h-3.5" /> LATEST ANNOUNCEMENT{latest.topic ? ` · ${latest.topic}` : ""}
        </div>
        <Link to="/dashboard/announcements" className="kb-mono text-[10px] uppercase tracking-wider text-kb-ink-muted hover:text-kb-primary inline-flex items-center gap-1">
          All announcements <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
      <h3 className="font-serif text-lg text-kb-ink mt-2">{latest.title}</h3>
      <div className="kb-mono text-[10px] uppercase tracking-wider text-kb-ink-muted mt-1">
        {latest.author_name} · {new Date(latest.created_at).toLocaleString()}
      </div>
      {latest.body && (
        <div className="mt-3 text-sm text-kb-ink kb-task-md leading-relaxed">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{`${preview}${bodyOverflow ? "…" : ""}`}</ReactMarkdown>
        </div>
      )}
    </div>
  );
}
